// extracted by mini-css-extract-plugin
export var container = "_h4-1";
export var editor = "_h4-2";
export var resizable = "_h4-3";
export var wrapper = "_h4-0";